export default __webpack_public_path__ + "static/media/bottom-banner-diamond.dc01e36b.gif";